import { render } from "./WorkspaceTemplate.vue?vue&type=template&id=4e7df3f8"
import script from "./WorkspaceTemplate.vue?vue&type=script&lang=js"
export * from "./WorkspaceTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__